import { colors } from '../primitives/colors';
const codeColors = {
    brackets: colors.pink[600],
    boostOperator: colors.gray[700],
    colon: colors.pink[600],
    field: colors.gray[600],
    not: colors.orange[800],
    andOr: colors.pink[600],
    to: colors.gray[600],
    number: colors.green[400],
    operator: colors.gray[700],
    operatorFuzzy: colors.gray[700],
    string: colors.orange[700],
    values: colors.gray[800],
    wildcard: colors.gray[700],
};
export const lightThemeColors = {
    surface: {
        default: colors.base.white,
        defaultAlt: colors.gray[100],
        subtle: colors.gray[50],
        elevated: colors.base.white,
    },
    gradient: {
        radiant: {
            stop1: colors.blue[500],
            stop2: colors.pink[500],
            stop3: colors.yellow[500],
        },
        recommended: {
            stop1: colors.blue[500],
            stop2: colors.pink[500],
            stop3: colors.orange[500],
        },
    },
    text: {
        code: codeColors,
        brand: colors.brand[600],
        positive: colors.success[700],
        negative: colors.error[600],
        warning: colors.warning[700],
        information: colors.blue[700],
        basic: {
            primary: colors.gray[800],
            secondary: colors.gray[700],
            tertiary: colors.gray[500],
            placeholder: colors.gray[400],
            description: colors.gray[400],
            disabled: colors.gray[400],
            inverse: colors.base.white,
            onColor: colors.base.white,
            onColorAlt: colors.gray[800],
        },
        link: {
            default: colors.brand[600],
            pressed: colors.brand[800],
            visited: colors.violet[600],
        },
    },
    code: codeColors,
    foreground: {
        default: colors.gray[600],
        subtle: colors.gray[500],
        preDefined: colors.gray[500],
        disabled: colors.gray[400],
        onColor: colors.base.white,
        onColorAlt: colors.gray[800],
        inverse: colors.base.white,
        brand: colors.blue[600],
        positive: colors.success[600],
        warning: colors.warning[600],
        negative: colors.error[600],
        information: colors.blue[600],
        starred: colors.yellow[400],
        violet: colors.violet[600],
    },
    effects: {
        focusRing: colors.brand[400],
        focusRingError: colors.error[400],
        shadowColor: colors.gray[950],
    },
    border: {
        default: colors.gray[250],
        control: colors.gray[300],
        alt: colors.gray[300],
        subtle: colors.gray[100],
        strong: colors.gray[400],
        disabled: colors.gray[300],
        inverse: colors.base.white,
        inverseSubtle: colors.gray[600],
        focus: colors.brand[400],
        brand: colors.brand[700],
        success: colors.success[600],
        danger: colors.error[600],
        warning: colors.warning[500],
        information: colors.blue[500],
    },
    dataVis: {
        vis1: colors.brand[600],
        vis2: colors.orange[600],
        vis3: colors.pink[500],
        vis4: colors.violet[600],
        vis5: colors.blue[500],
        vis6: colors.green[600],
        vis7: colors.yellow[600],
        vis8: colors.teal[700],
        vis9: colors.green[600],
        vis10: colors.pink[500],
        vis11: colors.gray[300],
    },
    severity: {
        critical: colors.error[700],
        high: colors.error[500],
        medium: colors.warningSerious[400],
        low: colors.yellow[400],
        info: colors.blue[300],
        debug: colors.gray[300],
        missing: colors.violet[300],
    },
    component: {
        default: colors.base.white,
        inverse: colors.gray[800],
        elevated: colors.base.white,
        inverseSubtle: colors.gray[600],
        emphasized: colors.gray[200],
        hover: colors.gray[100],
        active: colors.gray[200],
        isSelected: colors.brand[50],
        disabled: colors.gray[200],
        alt: {
            default: colors.gray[100],
            elevated: colors.gray[100],
            hover: colors.gray[300],
            active: colors.brand[200],
            isSelected: colors.brand[100],
        },
        bold: {
            default: colors.gray[200],
            hover: colors.gray[300],
            active: colors.gray[400],
        },
        brand: {
            default: colors.brand[600],
            hover: colors.brand[700],
            active: colors.brand[800],
        },
        brandLight: {
            default: colors.brand[100],
            hover: colors.brand[200],
            active: colors.brand[300],
        },
        negative: {
            default: colors.error[600],
            hover: colors.error[700],
            active: colors.error[800],
            isSelected: colors.error[200],
        },
        utility: {
            gray: {
                50: colors.gray[50],
                100: colors.gray[100],
                200: colors.gray[200],
                300: colors.gray[300],
                400: colors.gray[400],
                500: colors.gray[500],
                600: colors.gray[600],
                700: colors.gray[700],
            },
            yellow: {
                50: colors.yellow[50],
                100: colors.yellow[100],
                200: colors.yellow[200],
                300: colors.yellow[300],
                400: colors.yellow[400],
                500: colors.yellow[500],
                600: colors.yellow[600],
                700: colors.yellow[700],
            },
            green: {
                50: colors.green[50],
                100: colors.green[100],
                200: colors.green[200],
                300: colors.green[300],
                400: colors.green[400],
                500: colors.green[500],
                600: colors.green[600],
                700: colors.green[700],
            },
            orange: {
                50: colors.orange[50],
                100: colors.orange[100],
                200: colors.orange[200],
                300: colors.orange[300],
                400: colors.orange[400],
                500: colors.orange[500],
                600: colors.orange[600],
                700: colors.orange[700],
            },
            pink: {
                50: colors.pink[50],
                100: colors.pink[100],
                200: colors.pink[200],
                300: colors.pink[300],
                400: colors.pink[400],
                500: colors.pink[500],
                600: colors.pink[600],
                700: colors.pink[700],
            },
            red: {
                50: colors.error[50],
                100: colors.error[100],
                200: colors.error[200],
                300: colors.error[300],
                400: colors.error[400],
                500: colors.error[500],
                600: colors.error[600],
                700: colors.error[700],
            },
            indigo: {
                50: colors.indigo[50],
                100: colors.indigo[100],
                200: colors.indigo[200],
                300: colors.indigo[300],
                400: colors.indigo[400],
                500: colors.indigo[500],
                600: colors.indigo[600],
                700: colors.indigo[700],
            },
            violet: {
                50: colors.violet[50],
                100: colors.violet[100],
                200: colors.violet[200],
                300: colors.violet[300],
                400: colors.violet[400],
                500: colors.violet[500],
                600: colors.violet[600],
                700: colors.violet[700],
            },
            teal: {
                50: colors.teal[50],
                100: colors.teal[100],
                200: colors.teal[200],
                300: colors.teal[300],
                400: colors.teal[400],
                500: colors.teal[500],
                600: colors.teal[600],
                700: colors.teal[700],
            },
            blue: {
                50: colors.blue[50],
                100: colors.blue[100],
                200: colors.blue[200],
                300: colors.blue[300],
                400: colors.blue[400],
                500: colors.blue[500],
                600: colors.blue[600],
                700: colors.blue[700],
            },
        },
    },
    brandMarketing: {
        darkBlue: '#112031',
        neonYellow: '#FDFF37',
        middleBlue: '#004969',
        lightBlue: '#BBF0FF',
    },
};
//# sourceMappingURL=light-colors.js.map